import {PeachyRepoRoot} from '@peachy/repo-domain'
import {AbstractMapRepository, RepoEntityWithId} from '@peachy/flash-repo-pure'
import {PeachyRepoRootNode} from '../../types'

export abstract class PeachyMapRepository<RepoEntity extends RepoEntityWithId> extends AbstractMapRepository<RepoEntity, PeachyRepoRoot, PeachyRepoRootNode> { }
